import { getFormValue } from '../utils'
import { getMinBookingTime } from './get_min_booking_time'

export const prepareValuesForPreview = (eventType, formValues) => ({
  min_booking_time: getFormValue(
    eventType.min_booking_time,
    getMinBookingTime(formValues.minBookingTime, formValues.minBookingTimeType),
  )
})
